var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserMapping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11365 3428)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11363.667 -3426.667)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.893 6.185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1064.242,541.582a2.1,2.1,0,0,1-1.447-.665c-1.462-1.393-2.52-4.925-2.52-6.627a4.023,4.023,0,0,1,8.045,0c0,1.862-2.524,7.218-4,7.29Zm-.006-1Zm.062-9.308a3.02,3.02,0,0,0-3.017,3.017c0,1.5.989,4.738,2.208,5.9a1.157,1.157,0,0,0,.755.387h.005c.66-.28,3.065-4.42,3.065-6.286A3.02,3.02,0,0,0,1064.3,531.274Z",
    transform: "translate(-1060.276 -530.268)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1034.711,523.121H1024.54a3.738,3.738,0,0,1-3.618-3.84V509.5a3.738,3.738,0,0,1,3.618-3.84h7.119a3.738,3.738,0,0,1,3.618,3.84v2.679a.5.5,0,1,1-1.005,0V509.5a2.733,2.733,0,0,0-2.612-2.834h-7.119a2.733,2.733,0,0,0-2.612,2.834v9.778a2.733,2.733,0,0,0,2.612,2.834h10.171a.5.5,0,0,1,0,1.006Z",
    transform: "translate(-1020.922 -505.663)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.893 9.705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1064.3,552.061a2.05,2.05,0,0,1-1.437-.685c-1.478-1.455-2.59-5.01-2.59-6.6a.5.5,0,1,1,1.005,0,11.1,11.1,0,0,0,2.29,5.888,1.217,1.217,0,0,0,.719.4c.974-.061,3.024-4.29,3.024-6.285a.5.5,0,0,1,1.006,0c0,1.865-1.985,7.165-3.992,7.289Z",
    transform: "translate(-1060.276 -544.269)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.995 8.562)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.968,
    cy: 0.968,
    r: 0.968,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.437 4.419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1036.867,527.789a2.273,2.273,0,1,1,2.273-2.273A2.276,2.276,0,0,1,1036.867,527.789Zm0-3.541a1.268,1.268,0,1,0,1.268,1.268A1.269,1.269,0,0,0,1036.867,524.248Z",
    transform: "translate(-1034.594 -523.242)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.658 7.952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1028.022,541.329l-.043,0a.5.5,0,0,1-.458-.542,3.613,3.613,0,0,1,3.529-3.489.5.5,0,1,1,0,1.006c-2.271,0-2.517,2.463-2.526,2.568A.5.5,0,0,1,1028.022,541.329Z",
    transform: "translate(-1027.519 -537.297)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.395 7.952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1045.912,541.33a.5.5,0,0,1-.5-.46c-.009-.1-.256-2.568-2.527-2.568a.5.5,0,1,1,0-1.006,3.613,3.613,0,0,1,3.529,3.489.5.5,0,0,1-.459.543Z",
    transform: "translate(-1042.382 -537.297)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMapping);
export default __webpack_public_path__ + "static/media/User_Mapping.fd2479e5ad99554ea9112902d4968f13.svg";
export { ForwardRef as ReactComponent };